
















import Vue from "vue";

export default Vue.extend({
  name: "Paginator",

  props: {
    hasNextPage: {
      type: Boolean,
      default: false,
    },
    hasPreviousPage: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    prev() {
      this.$emit("prev-page");
    },
    next() {
      this.$emit("next-page");
    },
  },
});
